import { EvesTextbox } from '@/common/components/atoms/textbox/textbox';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const TargaConnection = (props: any) => {
	const { t: translate } = useTranslation();
		
	return <Grid container rowSpacing={1} columnSpacing={2} sx={{ marginTop:'8px'}}>
		<Grid item xs={6}>
			<Controller name="targaTelematicsConnection.authenticationUrl" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="authenticationUrl" label={`${translate('settings.car_connector.connection.authentication_url')} *`}
					data-cy="refunding-authenticationUrl"
					fullWidths
					variant="standard" 
					error={!!props.carConnectorForm.formState?.errors.targaTelematicsConnection?.authenticationUrl}
					helperText={`${translate(props.carConnectorForm.formState?.errors.targaTelematicsConnection?.authenticationUrl?.message || ' ')}`}
				/>
			)} />
		</Grid>
		<Grid item xs={6}>	
			<Controller name="targaTelematicsConnection.apiUrl" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="apiUrl" label={`${translate('settings.car_connector.connection.api_url')} *`}
					fullWidth 
					// required={props.requiredFields['targaTelematicsConnection.apiUrl']}
					variant="standard"
					error={!!props.carConnectorForm.formState?.errors?.targaTelematicsConnection?.apiUrl}
					helperText={`${translate(props.carConnectorForm.formState?.errors?.targaTelematicsConnection?.apiUrl?.message || ' ')}`}
				/>
			)} />
		</Grid>	
		<Grid item xs={6}>
			<Controller name="targaTelematicsConnection.clientId" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="clientId" label={`${translate('settings.car_connector.connection.client_id')} *`}
					data-cy="clientId"
					fullWidth
					// required={props.requiredFields['targaTelematicsConnection.clientId']}
					variant="standard"
					autoComplete="new-password"
					error={!!props.carConnectorForm.formState?.errors.targaTelematicsConnection?.clientId}
					helperText={`${translate(props.carConnectorForm.formState?.errors.targaTelematicsConnection?.clientId?.message || ' ')}`}
				/>
			)} />
		</Grid>
		<Grid item xs={6}>
			<Controller name="targaTelematicsConnection.clientSecret" control={props.carConnectorForm.control} render={({ field }) => (
				<EvesTextbox {...field} id="clientSecret" label={`${translate('settings.car_connector.connection.client_secret')} *`}
					data-cy="clientSecret"
					type="password"
					fullWidth
					// required={props.requiredFields['targaTelematicsConnection.clientSecret']}
					variant="standard"
					autoComplete="new-password"
					error={!!props.carConnectorForm.formState?.errors.targaTelematicsConnection?.clientSecret}
					helperText={`${translate(props.carConnectorForm.formState?.errors.targaTelematicsConnection?.clientSecret?.message || ' ')}`}
				/>
			)} />
		</Grid>
	</Grid>;
};

export default TargaConnection;